import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import FormCheckbox from "@ats/src/components/forms/FormCheckbox";

interface CreatedViaOption {
  value: string;
  label: string;
}

interface Props {
  options: CreatedViaOption[];
  activeFilters: Set<string>;
  onChange: (nextFilters: Set<string>) => void;
}

const CreatedViaFilterCheckboxes: React.FunctionComponent<Props> = ({
  options,
  activeFilters,
  onChange,
}) => {
  const handleFilterChange = (value: string, isChecked: boolean) => {
    const nextFilters = new Set(activeFilters);
    if (isChecked) {
      nextFilters.add(value);
    } else {
      nextFilters.delete(value);
    }
    onChange(nextFilters);
  };

  return (
    <Styled.Grid>
      {options.map((option) => (
        <Styled.Row key={option.value}>
          <FormCheckbox
            name={`all-filters-created-via-${option.value}`}
            label={option.label}
            checked={activeFilters.has(option.value)}
            onChange={(name, isChecked) => handleFilterChange(option.value, isChecked)}
          />
        </Styled.Row>
      ))}
    </Styled.Grid>
  );
};

export default CreatedViaFilterCheckboxes;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Grid = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: CreatedViaFilterCheckboxes;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 ${t.spacing[4]};
  `;
});

Styled.Row = styled.div`
  label: CreatedViaFilterCheckboxes_Row;
  display: flex;
  align-items: center;
`;
